<main id="main-content" class="main-content">
  <h2 class="form-header">WO Approval & Certification</h2>
  @for (region of regions; track region) {
    <mat-card>
      <div class="title">WO Signature and Certification
        @if (region.signature != null) {
          <mat-chip class="chip-4">SIGN & CERTIFIED</mat-chip>
        }
        @if (region.signature == null) {
          <mat-chip class="chip-high">NEEDS SIGNATURE</mat-chip>
        }
      </div>
      <div class="whole-line">
        <div class="quarter-div">
          <p class="data-title">Signed and Certified on</p>
          <p class="data-info">
            {{ region.signature?.created_on | date:"MM/dd/yyyy" | empty_check }}
          </p>
        </div>
        <div class="quarter-div">
          <p class="data-title">Signed By</p>
          <p class="data-info">{{ region.signature?.name ?? "--" }}</p>
        </div>
        <div class="quarter-div">
          <p class="data-title">Title</p>
          <p class="data-info">{{ region.signature?.title ?? "--" }}</p>
        </div>
      </div>
    </mat-card>
  }
</main>